import { Breakpoints } from '@/hooks/useBreakpoint';
import styled, { css } from 'styled-components';

export const Container = styled.div<{
  $selecionado: boolean;
  $breakpoint: Breakpoints;
  $expansivel: boolean;
}>`
  display: flex;
  flex-direction: column;
  justify-content: center;

  height: 100%;

  ${({ theme, $breakpoint }) => {
    const background = `linear-gradient(180deg, ${theme.panel.solid} 0%, #000 100%)`;
    return css`
      background: ${background};
      gap: ${theme.spacing[3]}px;
      padding: 0 ${theme.spacing[$breakpoint === 'desktop' ? 4 : 6]}px;
      padding-top: ${theme.spacing[$breakpoint === 'desktop' ? 4 : 3]}px;
      padding-bottom: ${theme.spacing[$breakpoint === 'desktop' ? 4 : 3]}px;
    `;
  }};

  cursor: pointer;
  overflow: hidden;
  border: ${({ $selecionado, theme }) =>
    $selecionado
      ? `2px solid ${theme.tokens.colors.text}`
      : `1px solid ${theme.colors.neutral.neutral_alpha[6]}`};

  ${({ $breakpoint, theme }) => {
    if ($breakpoint === 'mobile') {
      return css`
        border-radius: ${theme.radius[3]}px;
        width: 100%;
        min-height: 210px;
      `;
    }
    return css`
      border-top-right-radius: ${theme.radius[3]}px;
      border-bottom-left-radius: ${theme.radius[3]}px;
      width: 220px;
      min-height: 205px;
    `;
  }};

  ${({ $expansivel, $selecionado }) => {
    if (!$expansivel) return '';

    return css`
      width: ${$selecionado ? '228px' : '120px'};
    `;
  }}
`;

export const ContainerExpansivel = styled.div<{
  $expansivel: boolean;
  $selecionado: boolean;
}>`
  display: flex;
  align-items: start;

  flex-grow: 1;

  ${({ $expansivel, $selecionado }) => {
    if (!$expansivel) return '';

    return css`
      opacity: ${$selecionado ? 1 : 0};
      max-height: ${$selecionado ? '100%' : '0'};
      transition:
        opacity 0.3s ease,
        max-height 0.3s ease;
      overflow: hidden;
    `;
  }}
`;
